import {
  useAssignSetting,
  useSetting,
} from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/useSetting";
import { FE_BATCH_9_DIRECT_SIGN_UP_ON_SIGN_IN_041625 } from "@faire/retailer-settings/FE_BATCH_9_DIRECT_SIGN_UP_ON_SIGN_IN_041625";

export const useSettingBatch9DirectSignUpOnSignIn = (): boolean => {
  return useSetting(FE_BATCH_9_DIRECT_SIGN_UP_ON_SIGN_IN_041625);
};
export const useAssignSettingBatch9DirectSignUpOnSignIn = () =>
  useAssignSetting(FE_BATCH_9_DIRECT_SIGN_UP_ON_SIGN_IN_041625);
